// extracted by mini-css-extract-plugin
export default {"expandableIcon":"qfeYPLg5","active":"kLCtpaa5"};